import graphql__44924799ffcb2d14f933 from "./__generated__/ArchiveProjectDialog_project.graphql.ts";
import graphql__a2b6f07b82a299e4d0d6 from "./__generated__/ArchiveProjectDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useNavigate} from "react-router-dom";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useIntl} from "react-intl";

type ArchiveProjectDialogProps = {
    queryRef: any,
    handleCloseDialog: () => {}
}

const ArchiveProjectDialog: React.FC<ArchiveProjectDialogProps> = (props) => {

    const intl = useIntl();
    const navigate = useNavigate();
    const project = useFragment(
        graphql__44924799ffcb2d14f933,
        props.queryRef
    );

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__a2b6f07b82a299e4d0d6,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    props.handleCloseDialog();
                    navigate('/projects')
                },
                onError: (error) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToArchiveProject'})
            }
        )
    }

    const initialValues = {
        id: project.id
    }

    const projectDisplayName = project.projectName + (project.projectNumber ? ' (' + project.projectNumber + ')' : '');

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog}
                    handleSubmission={handleSubmission}
                    initialValues={initialValues}
                    headline={intl.formatMessage({id: 'dialog.ArchiveProjectDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'dialog.ArchiveProjectDialog.submitLabel'})}>
            <Section>
                <Row>
                    <p className="text-gray-900 font-medium">
                        {intl.formatMessage({id: 'dialog.ArchiveProjectDialog.confirmMessage'}, {name: projectDisplayName})}
                    </p>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default ArchiveProjectDialog;
